import React from 'react';
// import { connect } from 'react-redux';
import "react-vis/dist/style.css";
import {
    FlexibleXYPlot,
    LineSeries,
    VerticalGridLines,
    HorizontalGridLines,
    XAxis,
    YAxis,
    CustomSVGSeries,
    DiscreteColorLegend
} from "react-vis";
import { Col } from 'react-bootstrap';
import { Trans, withTranslation } from 'react-i18next';

class CurrentChart extends React.Component {
    constructor(props) {
        super(props);
    }

    clamp(number, min, max) {
        return Math.max(min, Math.min(number, max));
    }

    calcY(i, v, vmin, vmax, pmin, pmax) {
        if (i * v < pmin)
            return this.clamp(pmin / i, vmin, vmax);
        if (i * v > pmax)
            return this.clamp(pmax / i, vmin, vmax);
        return v;
    }

    graph(imin, imax, vmin, vmax, pmin, pmax) {
        const coordinates = [];
        for (var i = imax; i >= imin; i--) {
            var y = this.calcY(i, vmin, vmin, vmax, pmin, pmax)
            coordinates.push({x: i, y: y})
            if (y >= vmax)
                break;
        }
        for (let v = y; v < vmax; v++) {
            coordinates.push({x: i, y: v})
        }
        for (var i2 = i; i2 < imax; i2++) {
            y = this.calcY(i2, vmax, vmin, vmax, pmin, pmax)
            coordinates.push({x: i2, y: y})
            if (y < vmin)
                break;
        }
        for (let v = y; v >= this.calcY(i2, vmin, vmin, vmax, pmin, pmax); v--) {
            coordinates.push({x: i2, y: v})
        }
        return coordinates;
    }

    allowedArea(ux) {
        const imin = parseInt(ux.Imin)
        const imax = parseInt(ux.Imax)
        const umin = parseInt(ux.Umin)
        const umax = parseInt(ux.Umax)
        return this.graph(imin, imax, umin, umax, ux.Pmin*1000, ux.Pmax*1000);
    }

    performanceArea(ux, lp) {
        const imin = parseInt(ux.Imin)
        const imax = parseInt(ux.Imax)
        const umin = parseInt(ux.Umin)
        const umax = parseInt(ux.Umax)
        return this.graph(imin, imax, umin, umax, lp*1000, ux.Pmax*1000);
    }

    programmedArea(ux, minDim) {
        const imin = Math.max(ux.Imin, this.props.I * minDim/100);
        const imax = parseInt(this.props.I)
        const umin = parseInt(ux.Umin)
        const umax = this.calcY(imax, 10000, ux.Umin, ux.Umax, ux.Pmin*1000, ux.Pmax*1000)
        return this.graph(imin, imax, umin, umax, ux.Pmin*1000, ux.Pmax*1000);
    }

    render() {
        var curve_starting_point = 0;
        if (this.props.UI.Pmin * 1000 / this.props.UI.Umin <= this.props.UI.Imin){
            curve_starting_point = Math.max(this.props.UI.Imin, this.props.I * this.props.minDim/100);
        } else {
            curve_starting_point = Math.min(this.props.UI.Pmin * 1000 / this.props.UI.Umin, this.props.UI.Imax)
        }

        const legend1= [{
            title: <Trans i18nKey="Good_Performance_Area" />,
            color: "orange",
            disabled: false,
            data: [{ x: 0, y: 0 }, { x: 1, y: 220 }]
        }];

        const legend2= [{
            title: <Trans i18nKey="Programmed_Operating_Area" />,
            color: "DodgerBlue",
            disabled: false,
            data: [{ x: 0, y: 0 }, { x: 1, y: 220 }]
        }];

        const legend3= [{
            title: <Trans i18nKey="Allowed_Operating_Area" />,
            color: "green",
            strokeDasharray:'7, 3',
            disabled: false,
            data: [{ x: 300, y: 0 }, { x: 1, y: 220 }]
        }];

        const { t } = this.props;

        return (
            <div className="ChartsOne">
                <Col>
                    <FlexibleXYPlot height={400} width={400} yDomain={[0, Number(this.props.UI.Umax) + 20]}>

                        <HorizontalGridLines />
                        <VerticalGridLines />
                        <XAxis title={t("Current_graph")} tickTotal={5}/>
                        <YAxis title={t("Voltage_graph")} />

                        <LineSeries data={this.allowedArea(this.props.UI)} color={"green"} strokeDasharray={'7, 3'} />

                        {this.props.lowPower != 0 ?
                            <LineSeries data={this.performanceArea(this.props.UI, this.props.lowPower)} color={"orange"} />
                            : null}
                        <LineSeries data={this.programmedArea(this.props.UI, this.props.minDim)} color={"DodgerBlue"} />

                        {/* point top right */}
                        <CustomSVGSeries
                            className="custom-marking"
                            customComponent={(row, positionInPixels) => {
                                return (
                                    <g className="inner-inner-component">
                                        <circle cx="0" cy="0" r={2} fill="green" />
                                        <text x={0} y={0}>
                                            <tspan x="0" y="0">{`(${Math.round(Math.max(this.props.UI.Pmax * 1000 / this.props.UI.Umax, (Math.max(this.props.UI.Pmin * 1000 / this.props.UI.Imax, this.props.UI.Umin))))}, ${Math.round(this.props.UI.Pmax * 1000 / (Math.max(this.props.UI.Pmax * 1000 / this.props.UI.Umax, Math.max(this.props.UI.Pmin * 1000 / this.props.UI.Imax, this.props.UI.Umin))))})`}</tspan>
                                        </text>
                                    </g>
                                );
                            }}
                            data={[
                                {x: Math.max(this.props.UI.Pmax * 1000 / this.props.UI.Umax, (Math.max(this.props.UI.Pmin * 1000 / this.props.UI.Imax, this.props.UI.Umin))), y: (this.props.UI.Pmax * 1000 / (Math.max(this.props.UI.Pmax * 1000 / this.props.UI.Umax, Math.max(this.props.UI.Pmin * 1000 / this.props.UI.Imax, this.props.UI.Umin)))), size: 1},
                            ]}
                        />

                        {/* point bottom left */}
                        <CustomSVGSeries
                            className="custom-marking"
                            customComponent={(row, positionInPixels) => {
                                return (
                                    <g className="inner-inner-component">
                                        <circle cx="0" cy="0" r={2} fill="green" />
                                        <text x={0} y={0}>
                                            <tspan x="0" y="0">{`(${Math.round(curve_starting_point) }, ${Math.round(Math.max(this.props.UI.Pmin * 1000 / this.props.UI.Imax, this.props.UI.Umin)) })`}</tspan>
                                        </text>
                                    </g>
                                );
                            }}
                            data={[
                                {x: curve_starting_point, y: Math.max(this.props.UI.Pmin * 1000 / this.props.UI.Imax, this.props.UI.Umin), size: 1},
                            ]}
                        />

                    </FlexibleXYPlot>
                </Col>
                <Col>
                    {this.props.lowPower != 0 ?
                        <DiscreteColorLegend
                            width={180}
                            items={legend1}
                        />
                        : null}
                    <DiscreteColorLegend
                        width={250}
                        items={legend2}
                    />
                    <DiscreteColorLegend
                        width={250}
                        items={legend3}
                    />
                </Col>

            </div>
        );
    };
}

export default withTranslation()(CurrentChart);
